// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__5f6K+","logo":"navbar_logo__2HVGs","jazzicon":"navbar_jazzicon__krFeM"};